var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmountWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.00163C16 5.10516 15.916 5.18909 15.8125 5.18909H7.96086C7.84815 5.18909 7.82156 5.03163 7.92803 4.99463L13.3434 3.11248C14.643 2.66079 16 3.62577 16 5.00163Z",
    fill: "#077734"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21H5C3.34315 21 2 19.6569 2 18V10C2 8.69378 2.83481 7.58254 4 7.17071C4.31278 7.06015 4.64936 7 5 7H18C19.5727 7 20.8627 8.21016 20.9897 9.75008C21.0011 9.88768 20.8881 10 20.75 10H15C12.7909 10 11 11.7909 11 14C11 16.2091 12.7909 18 15 18H20.75C20.8881 18 21.0011 18.1123 20.9897 18.2499C20.8627 19.7898 19.5727 21 18 21Z",
    fill: "#077734"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12H21.5C21.7761 12 22 12.2239 22 12.5V15.5C22 15.7761 21.7761 16 21.5 16H15C13.8954 16 13 15.1046 13 14C13 12.8954 13.8954 12 15 12ZM16 14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13C15.5523 13 16 13.4477 16 14Z",
    fill: "#077734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountWallet);
export default __webpack_public_path__ + "static/media/amount-wallet.9fde7919d83b8a1bb4f518cd79d9f002.svg";
export { ForwardRef as ReactComponent };